module.exports = __webpack_public_path__ + "e6dd16ccb723e68aadbe73450cedb691.svg";